<nav class="navbarColorTheme row navbar navbar-expand-lg navbar-dark navborder m-0 p-2 d-flex flex-xl-row flex-lg-row  flex-md-row flex-sm-column flex-xs-column" id="dark" style=" width:100%;">

  <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-l2 d-flex align-items-center p-0 my-md-2 my-sm-2 my-xs-2 my-0">

    <div class="mx-3 p-0">
      <a type="button"
        [style]="isEGID?isDarkTheme?{background: navButtonColor}:{background: 'white'}:{background: navButtonColor}"
        [href]="logoLink" class="btn  shadow-none"
        [class.btn-light]="isEGID"
        [class.btn-radius]="isEGID">
        <img style="max-width:140px"
          [src]="isEGID?isDarkTheme?'./assets/identity/nav-button-logo.png':'./assets/identity/nav-button-logo-2.png':'./assets/identity/nav-button-logo.png'"
          class="logo-hover">
      </a>
    </div>

    <div class="autocomplete">
      <div class="search-bar">
        <input type="text" [(ngModel)]="searchValue" [disabled]="!companies" class="form-control"
          placeholder="{{'search-bar-text'|translate}}" (keyup)="credentialsSearchFilter($event)">
        <button class="clearButton" *ngIf="searchValue" matSuffix mat-icon-button aria-label="Clear"
          (click)="searchValue=''">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <div *ngIf="records.length > 0 && searchValue" class="suggestion-list">
        <div *ngFor="let record of records" class="d-flex justify-content-between search-result-div">
          <div (click)="navigateProfile(record)"
            style="width:55%;cursor:pointer;padding-inline-end: 10px;padding-inline-start: 10px;white-space: nowrap;overflow: hidden;align-self:center;text-overflow: ellipsis;vertical-align:middle; text-align: start;">
            {{(translate.currentLang=='en')?record.ENG_NAME:record.ARB_NAME}}
          </div>
          <div (click)="navigateProfile(record)" class="p-2"
            style="cursor:pointer;align-self: center; min-width: 50px;max-width: 50px;">
            {{record.LAST_TRADE_PRICE | number: "1.2-3":"en-US"}}
          </div>
          <div class="my-class-container">
            <button (click)="orderBuy(record, 0)" mat-flat-button class="my-class"
              style="background: #26de81; line-height: 32px; font-size: smaller;">
              B
            </button>
          </div>
          <div class="my-class-container">
            <button (click)="orderBuy(record, 1)" mat-flat-button class="my-class"
              style="background: #ff231f; line-height: 32px; font-size: smaller;">
              S
            </button>
          </div>
          <div class="my-class-container">
            <button mat-icon-button (click)="toggleFav(record.SYMBOL_CODE)"
              style="color: rgb(129, 0, 0); line-height: 32px; font-size: smaller;">
              <mat-icon class="icon-color" *ngIf="isFav(record.SYMBOL_CODE)"
                aria-label="Example icon-button with a heart icon">
                favorite
              </mat-icon>
              <mat-icon class="icon-color" *ngIf="!isFav(record.SYMBOL_CODE)"
                aria-label="Example icon-button with a heart icon">
                favorite_border
              </mat-icon>
            </button>

          </div>
        </div>
      </div>
    </div>

    <div class=" d-xl-none d-lg-none d-md-block d-sm-block d-xs-block menu-icon mx-3">
      <mat-icon class="icon-color" (click)="toggleMenu()">menu</mat-icon>
    </div>

  </div>

  <div class="px-0 col-xl-8 col-lg-8 col-md-12 col-sm-12 col-xs-l2 d-flex flex-xl-row flex-lg-row flex-md-column-reverse flex-sm-column-reverse flex-xs-column-reverse flex-column-reverse align-items-center">
    <div class=" col-xl-9 col-lg-9 col-md-12 col-sm-12 col-xs-l2 p-0 my-md-2 my-sm-2 my-xs-2 my-0" [ngClass]="{'d-block':showMenu}" [ngClass]="{'d-none':!showMenu}" >
      <app-home-market-summary></app-home-market-summary>
    </div>
  
    <div class="col-xl-3 col-lg-3 col-md-12 col-sm-12 col-xs-l2 px-0 d-flex my-md-2 my-sm-2 my-xs-2 my-0" style="justify-content: space-evenly;">
  
      <div>
        <button ngbTooltip="{{'home-tooltip'|translate}}" placement="bottom" class="action-button icon-color"
          mat-icon-button [routerLink]="'./home'">
          <mat-icon>home</mat-icon>
        </button>
        <span class="nav-label">{{ 'home-tooltip' | translate }}</span>
      </div>
  
  
  
      <div>
        <button ngbTooltip="{{'profile'|translate}}" placement="bottom" class="action-button icon-color" mat-icon-button
          [routerLink]="'./profile'">
          <mat-icon>business_center</mat-icon>
        </button>
        <span class="nav-label">{{ 'profile' | translate }}</span>
      </div>
        <div>
        <button
          class="action-button"
          mat-icon-button
          [routerLink]="'./requests-analysis/requests-table'"
        >
          <mat-icon class="action-button"  ngbTooltip="{{ 'requests-analysis' | translate }}">request_page</mat-icon>
        </button>
        <span class="nav-label">{{ 'requests-analysis' | translate }}</span>        
      </div>
      <div  *ngIf="device === 'desktop'" ngbDropdown class="d-inline-block mx-lg-0 mx-2">
        <button ngbTooltip="{{'widgets-tooltip'|translate}}" placement="bottom" class="action-button icon-color"
          mat-icon-button ngbDropdownToggle>
          <mat-icon>widgets</mat-icon>
        </button>
        <span class="nav-label">{{ 'widgets-tooltip' | translate }}</span>        
        <div ngbDropdownMenu style="width: 200px;padding: 0px; border-radius: 10px; text-align: start; "
          [ngStyle]="translate.currentLang == 'en'?{'left': '-100px'}:{'right': '-100px'}">
          <div style="margin: 15px; text-align: center;">
            <span class="text-color-theme">{{"add-widgets" | translate}}</span>
          </div>
          <hr style="background: #6c757d!important; width: 60%;">
          <button ngbDropdownItem (click)="addWidget('market-watch')">
            {{"market"|translate}}
          </button>
          <button ngbDropdownItem (click)="addWidget('market-trades')">
            {{"market-trades"|translate}}
          </button>
          <button ngbDropdownItem (click)="addWidget('trades')">
            {{"symbol-trades"|translate}}
          </button>
          <button ngbDropdownItem (click)="addWidget('market-depth')">
            {{"market-depth"|translate}}
          </button>
          <button ngbDropdownItem (click)="addWidget('market-news')">
            {{"market-news"|translate}}
          </button>
          <button ngbDropdownItem (click)="addWidget('news')">
            {{"stock-news"|translate}}
          </button>
          <button ngbDropdownItem (click)="addWidget('historical')">
            {{"historical-data"|translate}}
          </button>
          <button ngbDropdownItem (click)="addWidget('order-book')">
            {{"order-book"|translate}}
          </button>
          <!-- <button ngbDropdownItem (click)="addWidget('chart')">
            {{"chart"|translate}}
          </button> -->
          <ng-container *ngIf="currentUrl === '/' || currentUrl === '/home' || currentUrl === '/test'">
            <hr style="background: #6c757d !important; width: 60%" />
            <button ngbDropdownItem (click)="resetDashboard()" class="text-center my-3">
              <small class="text-warning">{{
                "reset-dashboard" | translate
                }}</small>
            </button>
          </ng-container>
        </div>
      </div>
  
      <div ngbDropdown class="d-inline-block mx-lg-0 mx-2">
        <button ngbTooltip="{{'menu-tooltip'|translate}}" placement="bottom" class="action-button icon-color"
          mat-icon-button ngbDropdownToggle>
          <mat-icon>apps</mat-icon>
        </button>
                <span class="nav-label">{{ 'menu-tooltip' | translate }}</span>        
        <div ngbDropdownMenu [style.left]="(translate.currentLang=='en')?'-350px':'-50px'"
          style="width: 380px; border-radius: 10px;">
          <div class="containerr">
            <div class="col-4 p-0 bg-transparent" ngbDropdownItem [routerLink]="'/invoice'">
              <div class="card navbar-card-tab">
                <div class="content content-bg ">
                  <div class="imgBx">
                    <img src="./assets/nav-icons/my-invoices.svg">
                  </div>
                </div>
                <div class="sci">
                  <li class="text-color-theme">
                    {{"my-invoices"|translate}}
                  </li>
                </div>
              </div>
              <div class="static-card-label text-color-theme">{{ "my-invoices" | translate }}</div>
            </div>
            <div class="col-4 p-0 bg-transparent" ngbDropdownItem (click)="statmentDialog()">
              <div class="card navbar-card-tab">
                <div class="content content-bg">
                  <div class="imgBx">
                    <img src="./assets/nav-icons/my-statements.svg">
                  </div>
                </div>
                <div class="sci">
                  <li class="text-color-theme">
                    {{"my-statement"|translate}}
                  </li>
                </div>
              </div>
              <div class="static-card-label text-color-theme">{{ "my-statement" | translate }}</div>
            </div>
            <div class="col-4 p-0 bg-transparent" ngbDropdownItem [routerLink]="'/tradesHistory'">
              <div class="card navbar-card-tab">
                <div class="content content-bg">
                  <div class="imgBx">
                    <img src="./assets/nav-icons/trading-history.svg">
                  </div>
                </div>
                <div class="sci">
                  <li class="text-color-theme">
                    {{'trading-history'|translate}}
                  </li>
                </div>
              </div>
              <div class="static-card-label text-color-theme">{{ "trading-history" | translate }}</div>
            </div>
            <div class="col-4 p-0 bg-transparent" [disabled]="!isMarket" ngbDropdownItem [routerLink]="'/local'">
              <div class="card navbar-card-tab">
                <div class="content content-bg">
                  <div class="imgBx">
                    <img src="./assets/nav-icons/local-market.svg">
                  </div>
                </div>
  
                <div class="sci">
                  <li class="text-warning" *ngIf="!isMarket">
                    {{'only-subscribed'|translate}}
                  </li>
                  <li class="text-color-theme" *ngIf="isMarket">
                    {{'local-market'|translate}}
                  </li>
                </div>
  
              </div>
               <div class="static-card-label text-color-theme">{{ "local-market" | translate }}</div>
            </div>
            <div class="col-4 p-0 bg-transparent" [disabled]="!isMarket" ngbDropdownItem [routerLink]="'/global'">
              <div class="card navbar-card-tab">
                <div class="content content-bg">
                  <div class="imgBx">
                    <img src="./assets/nav-icons/global-market.svg">
                  </div>
                </div>
                <div class="sci">
                  <li class="text-warning" *ngIf="!isMarket">
                    {{'only-subscribed'|translate}}
                  </li>
                  <li class="text-color-theme" *ngIf="isMarket">
                    {{'global-market'|translate}}
                  </li>
                </div>
                <!-- <span class="mt-2" style="font-size: 13px" *ngIf="!isMarket">
                  {{'global-market'|translate}}
                </span>
                <span style="font-size: 10px" class="text-warning mt-1" *ngIf="!isMarket">
                  {{'only-subscribed'|translate}}
                </span> -->
  
              </div>
              <div class="static-card-label text-color-theme">{{ "global-market" | translate }}</div>
            </div>
  
            <div
            *ngIf="enableMutualFund"
            class="col-4 p-0 bg-transparent"
            ngbDropdownItem
            [routerLink]="'/mutual-fund'"
          >
            <div class="card navbar-card-tab">
              <div class="content content-bg">
                <div class="imgBx">
                  <img src="/assets/nav-icons/mutual-fund.svg" />
                </div>
              </div>
              <div class="sci">
                <li class="text-color-theme">
                  {{ "mutual-fund" | translate }}
                </li>
              </div>
            </div>
            <div class="static-card-label text-color-theme">{{ "mutual-fund" | translate }}</div>
          </div>
  
            <div
              *ngIf="hasTechnicalAnalysis || hasFundmentalAnalysis"
              class="col-4 p-0 bg-transparent"
              ngbDropdownItem
              [routerLink]="'./reports'"
            >
              <div class="card navbar-card-tab">
                <div class="content content-bg">
                  <div class="imgBx">
                    <img src="/assets/nav-icons/grow-up-icon.svg" />
                  </div>
                </div>
                <div class="sci">
                  <li class="text-color-theme">
                    {{ "reports" | translate }}
                  </li>
                </div>
              </div>
              <div class="static-card-label text-color-theme">{{ "reports" | translate }}</div>
            </div>
  
            <div *ngIf="!hasTechnicalAnalysis" class="col-4 p-0 bg-transparent" ngbDropdownItem
              (click)="openTechAnalysisModal()">
              <div class="card navbar-card-tab">
                <div class="content content-bg">
                  <div class="imgBx">
                    <img src="./assets/nav-icons/tech-analysis.svg">
                  </div>
                </div>
                <div class="sci">
                  <li class="text-color-theme">
                    {{'technical-analysis'|translate}}
                  </li>
                </div>
              </div>
               <div class="static-card-label text-color-theme">{{ "technical-analysis" | translate }}</div>
            </div>
  
            <div *ngIf="enableIPO" class="col-4 p-0 bg-transparent" ngbDropdownItem [routerLink]="'./IPO'">
              <div class="card navbar-card-tab">
                <div class="content content-bg">
                  <div class="imgBx">
                    <img src="assets/img/Frame.png" alt="">
                  </div>
                </div>
                <div class="sci">
                  <li class="text-color-theme">
                    {{'IPO'|translate}}
                  </li>
                </div>
              </div>
              <div class="static-card-label text-color-theme">{{ "IPO" | translate }}</div>
            </div>
  
            <div class="col-4 p-0 bg-transparent" ngbDropdownItem (click)="settings()">
              <div class="card navbar-card-tab">
                <div class="content content-bg">
                  <div class="imgBx">
                    <img src="./assets/nav-icons/settings.svg">
                  </div>
                </div>
                <div class="sci">
                  <li class="text-color-theme">
                    {{'settings'|translate}}
                  </li>
                </div>
              </div>
               <div class="static-card-label text-color-theme">{{ "settings" | translate }}</div>
            </div>
            <div class="col-4 p-0 bg-transparent" ngbDropdownItem (click)="switchLang()">
              <div class="card navbar-card-tab">
                <div class="content content-bg">
                  <div class="imgBx">
                    <img src="./assets/nav-icons/switch-lang.svg">
                  </div>
                </div>
                <div class="sci">
                  <li class="text-color-theme">
                    {{'switch-lang'|translate}}
                  </li>
                </div>
              </div>
               <div class="static-card-label text-color-theme">{{ "switch-lang" | translate }}</div>
            </div>
            <div class="col-4 p-0 bg-transparent" ngbDropdownItem (click)="logout()">
              <div class="card navbar-card-tab">
                <div class="content content-bg">
                  <div class="imgBx">
                    <img src="./assets/nav-icons/logout.svg">
                  </div>
                </div>
                <div class="sci">
                  <li class="text-color-theme">
                    {{'logout'|translate}}
                  </li>
                </div>
              </div>
               <div class="static-card-label text-color-theme">{{ "logout" | translate }}</div>
            </div>
  
          </div>
        </div>
      </div>
  
      <div>
        <button ngbTooltip="{{'fullscreen'|translate}}" placement="bottom" class="action-button icon-color"
          mat-icon-button (click)="isFullscreen? closeFullscreen():openFullscreen()">
          <mat-icon>fullscreen</mat-icon>
        </button>
                <span class="nav-label">{{ 'fullscreen' | translate }}</span>        
      </div>
    </div>
  </div>
</nav>
<div class="not-market-hint" *ngIf="!isMarket">
  <p>
    {{'not-full-market-title'|translate}}
  </p>
</div>